import { GTMCartProduct, PageViewData } from '../GTM'
import { CurrencyEnum } from '@pylot-data/enums/CurrencyEnum'

export const isCartState = (
    data: Record<string, unknown>
): data is {
    currencyCode: CurrencyEnum
    productsDetails?: GTMCartProduct[]
} => {
    if (typeof data !== 'object' || !data) {
        return false
    }
    const keys = Object.keys(data)
    return (
        keys.includes('currencyCode') &&
        typeof data.currencyCode === 'string' &&
        Object.values(CurrencyEnum).includes(data.currencyCode as CurrencyEnum)
    )
}

export const storeCartState = (
    data: Record<string, unknown>,
    addStoredData: (data: PageViewData) => void
): void => {
    if (!isCartState(data)) {
        return
    }
    const { productsDetails = [], currencyCode } = data
    // Reorder items properly
    productsDetails.reverse()

    addStoredData({
        cartContents: {
            currencyCode,
            products: productsDetails
        }
    })
}
